import React from 'react'
import { HiMiniUsers } from "react-icons/hi2";

const CourseCard = ({cardData,currentCard,setCurrentCard}) => {
  return (
    <div className={` ${ cardData.heading ===currentCard 
        ?"bg-richblack-5 text-richblack-800 box_shadow" 
        :"bg-richblack-700 text-richblack-5" } 
        lg:w-[30%] w-[80%] mx-auto transition-all duration-200 rounded-sm`}
        onClick={() =>setCurrentCard(cardData.heading)}
        
        >

        <div className='flex flex-col mt-2 mb-20 px-6 py-6'>
            <p className='text-xl mb-1 font-semibold'>{cardData.heading}</p>
            <p className='text-richblack-300  '>
                {cardData.description}
            </p>
        </div>

        <div className='horizontal-dotted-line'></div>
        <div className={`flex flex-row justify-between px-6 py-3 text-blue-300
           `}
            >
            <div className='flex flex-row gap-2'>
                <HiMiniUsers/>
                <div>{cardData.level}</div>
            </div>

            <div className='flex flex-row gap-2  '>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                    <g clipPath="url(#clip0_11167_18357)">
                        <path d="M16.834 13.6382V13.5002C16.8328 12.506 16.4373 11.5528 15.7343 10.8498C15.0313 10.1468 14.0782 9.75136 13.084 9.75017H10.084V8.93267C11.1965 8.74461 12.1978 8.14547 12.8895 7.25396C13.5811 6.36246 13.9126 5.24367 13.8182 4.11929C13.7239 2.99491 13.2106 1.94701 12.38 1.18325C11.5495 0.419487 10.4623 -0.00439453 9.33399 -0.00439453C8.20566 -0.00439453 7.1185 0.419487 6.28796 1.18325C5.45742 1.94701 4.94411 2.99491 4.84975 4.11929C4.75539 5.24367 5.08688 6.36246 5.77851 7.25396C6.47014 8.14547 7.47144 8.74461 8.58399 8.93267V9.75017H5.58399C4.58979 9.75136 3.63666 10.1468 2.93365 10.8498C2.23065 11.5528 1.83518 12.506 1.83399 13.5002V13.6382C1.33358 13.8151 0.911823 14.1632 0.643265 14.621C0.374708 15.0788 0.276639 15.6168 0.366392 16.14C0.456146 16.6631 0.727942 17.1376 1.13374 17.4797C1.53955 17.8219 2.05322 18.0095 2.58399 18.0095C3.11475 18.0095 3.62843 17.8219 4.03423 17.4797C4.44004 17.1376 4.71183 16.6631 4.80159 16.14C4.89134 15.6168 4.79327 15.0788 4.52471 14.621C4.25616 14.1632 3.8344 13.8151 3.33399 13.6382V13.5002C3.33399 12.9034 3.57104 12.3311 3.993 11.9092C4.41496 11.4872 4.98725 11.2502 5.58399 11.2502H8.58399V13.6382C8.08358 13.8151 7.66182 14.1632 7.39327 14.621C7.12471 15.0788 7.02664 15.6168 7.11639 16.14C7.20615 16.6631 7.47794 17.1376 7.88375 17.4797C8.28955 17.8219 8.80322 18.0095 9.33399 18.0095C9.86476 18.0095 10.3784 17.8219 10.7842 17.4797C11.19 17.1376 11.4618 16.6631 11.5516 16.14C11.6413 15.6168 11.5433 15.0788 11.2747 14.621C11.0062 14.1632 10.5844 13.8151 10.084 13.6382V11.2502H13.084C13.6807 11.2502 14.253 11.4872 14.675 11.9092C15.0969 12.3311 15.334 12.9034 15.334 13.5002V13.6382C14.8336 13.8151 14.4118 14.1632 14.1433 14.621C13.8747 15.0788 13.7766 15.6168 13.8664 16.14C13.9561 16.6631 14.2279 17.1376 14.6337 17.4797C15.0395 17.8219 15.5532 18.0095 16.084 18.0095C16.6148 18.0095 17.1284 17.8219 17.5342 17.4797C17.94 17.1376 18.2118 16.6631 18.3016 16.14C18.3913 15.6168 18.2933 15.0788 18.0247 14.621C17.7562 14.1632 17.3344 13.8151 16.834 13.6382Z" fill="#0F7A9D"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_11167_18357">
                        <rect width="18" height="18" fill="white" transform="translate(0.333984)"/>
                        </clipPath>
                    </defs>
                </svg>
                <p>{`${cardData.lessionNumber} Lesson`}</p>
            </div>

        </div>
    </div>
  )
}

export default CourseCard